export const matchTypes = {
  AUDIENCE_VARIABLE: 'AUDIENCE_VARIABLE',
  QUESTION: 'QUESTION',
  CONSTANT: 'CONSTANT',
  IGNORE: 'IGNORE',
};

export const matchTypeOptions = [
  {
    key: matchTypes.AUDIENCE_VARIABLE,
    label: 'Audience Variable',
    value: matchTypes.AUDIENCE_VARIABLE,
  },
  {
    key: matchTypes.QUESTION,
    label: 'Question',
    value: matchTypes.QUESTION,
  },
  {
    key: matchTypes.CONSTANT,
    label: 'Constant',
    value: matchTypes.CONSTANT,
  },
  {
    key: matchTypes.IGNORE,
    label: 'Ignore',
    value: matchTypes.IGNORE,
  },
];
